import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=4c71cc42&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c71cc42",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c71cc42')) {
      api.createRecord('4c71cc42', component.options)
    } else {
      api.reload('4c71cc42', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=4c71cc42&scoped=true&", function () {
      api.rerender('4c71cc42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2QiTxy0Jx880e/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports